import type {
  Review,
  CreateReviewRequest,
  UpdateReviewRequest,
  ReorderReviewsRequest,
} from '../features/reviews/types';
import { api } from './client';

export async function getReviews(): Promise<Review[]> {
  return api.get<Review[]>('/api/reviews');
}

export async function getPublicReviews(): Promise<Review[]> {
  return api.get<Review[]>('/api/reviews/public');
}

export async function getReviewById(id: string): Promise<Review> {
  return api.get<Review>(`/api/reviews/${id}`);
}

export async function createReview(data: CreateReviewRequest): Promise<Review> {
  return api.post<Review>('/api/reviews', data);
}

export async function updateReview(id: string, data: UpdateReviewRequest): Promise<Review> {
  return api.patch<Review>(`/api/reviews/${id}`, data);
}

export async function deleteReview(id: string): Promise<void> {
  return api.delete(`/api/reviews/${id}`);
}

export async function reorderReviews(
  data: ReorderReviewsRequest
): Promise<{ success: boolean }> {
  return api.post<{ success: boolean }>('/api/reviews/reorder', data);
}

